export default __webpack_public_path__ + "static/media/betty.3d1ff535.jpg";